import { Uuid } from 'ValueObjects';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { Collection, Pagination } from 'Requests';
import { ExactOnlineBankAccount } from 'Models/Synchronizer/Package/ExactOnline';

type Response = AxiosResponse<Collection<ExactOnlineBankAccount>>;

export type ExactOnlineBankAccountsByCredentialIdRequestProps = Pagination & {
  credentialId: Uuid;
  division: string | number;
};

export const ExactOnlineBankAccountsByCredentialIdRequest = async ({
  credentialId,
  division,
}: ExactOnlineBankAccountsByCredentialIdRequestProps): Promise<Response> =>
  axios.get(`api/${credentialId}/data/exact-online/${division}/bank-accounts`);

export const useExactOnlineBankAccountsByCredentialIdRequestQuery = (
  request: ExactOnlineBankAccountsByCredentialIdRequestProps,
  options: UseQueryOptions<Response, AxiosError, Response> = {}
): UseQueryResult<Response, AxiosError> =>
  useQuery<Response, AxiosError, Response>({
    ...options,
    queryFn: async () => ExactOnlineBankAccountsByCredentialIdRequest(request),
    queryKey: [
      'exact-online',
      'bank-accounts',
      'list',
      request.credentialId,
      request.division,
      JSON.stringify({ perPage: request.perPage, page: request.page }),
    ],
  });
